import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

function authConfig(config = {}) {
  const token = window.localStorage.getItem('token');
  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
}

export function normalizeIntelligencePhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  return digits.length >= 9 ? digits.slice(-9) : null;
}

export async function getRegistrationPreview(
  phones,
  { context = 'single', rowCount, signal } = {}
) {
  const payload = { phones, context };
  if (Number.isFinite(Number(rowCount))) payload.row_count = Number(rowCount);
  const response = await axios.post(
    `${API_URL}/api/user/delivery-intelligence/registration-preview`,
    payload,
    authConfig({ signal })
  );
  return response.data;
}

export async function getDeliveryIntelligenceWatch(params = {}) {
  const response = await axios.get(
    `${API_URL}/api/user/delivery-intelligence/watch`,
    authConfig({ params })
  );
  return response.data;
}

export async function getDeliveryIntelligenceSummary(params = {}) {
  const response = await axios.get(
    `${API_URL}/api/user/delivery-intelligence/summary`,
    authConfig({ params })
  );
  return response.data;
}

export async function getDeliveryIntelligenceDetail(deliveryPointId, params = {}) {
  const response = await axios.get(
    `${API_URL}/api/user/delivery-intelligence/watch/${deliveryPointId}`,
    authConfig({ params })
  );
  return response.data;
}

